export const FIELD_COPY = {
  storeId: {
    label: "the order's store",
    help: 'Choose the ShipStation store the order belongs to.'
  },
  countryCode: {
    label: 'the ship-to country',
    help: 'The destination country, such as US, CA or MX.'
  },
  state: {
    label: 'the ship-to state',
    help: 'The destination state or province. Use its two-letter code for US states.'
  },
  postalPrefix: {
    label: 'the ZIP code',
    help: 'Starts with checks the beginning of the postal code, such as 902.'
  },
  residential: {
    label: 'the address is residential',
    help: 'Whether ShipStation identifies the destination as a home.'
  },
  weightOz: {
    label: 'the package weight',
    unit: 'oz',
    help: 'Weight of the first package in ounces. 16 oz = 1 lb.'
  },
  longestSideIn: {
    label: 'the longest box side',
    unit: 'in',
    help: 'The longest package dimension, in inches.'
  },
  itemCount: {
    label: 'the number of items',
    help: 'The total quantity of items in this order.'
  },
  orderTotal: {
    label: 'the order total',
    unit: '$',
    help: 'The amount paid for the order, in dollars.'
  },
  tag: {
    label: "the order's ShipStation tags",
    help: 'Include any of matches at least one selected tag. Matching ignores upper/lower case.'
  },
  sku: {
    label: "the order's SKUs",
    help: 'Match item SKUs, or check how a SKU starts.'
  },
  externalOrderId: {
    label: 'the marketplace order number',
    help: 'The order number assigned by the marketplace.'
  }
};
export const OPERATOR_WORDS = {
  eq: 'is',
  neq: 'is not',
  in: 'is one of',
  not_in: 'is not one of',
  gt: 'is more than',
  gte: 'is at least',
  lt: 'is less than',
  lte: 'is at most',
  between: 'is between',
  contains: 'contains',
  starts_with: 'starts with',
  has: 'include any of',
  not_has: 'include none of'
};
export const ACTION_COPY = {
  skip: {
    label: 'Leave this order alone',
    help: 'Keep its current shipping choice and do not change it.'
  },
  exclude_services: {
    label: 'Never use these services',
    help: 'Remove these services from the prices that may win.'
  },
  only_services: {
    label: 'Only allow these services',
    help: 'Choose only from these services, if they are allowed to win in Settings.'
  },
  exclude_carriers: {
    label: 'Never use these carrier accounts',
    help: 'Do not choose a price from these accounts.'
  },
  only_carriers: {
    label: 'Only use these carrier accounts',
    help: 'Limit the choice to these accounts.'
  },
  exclude_groups: {
    label: "Don't check these rating methods",
    help: 'Do not ask ShipStation for prices using these methods.'
  },
  force_service: {
    label: "Always use this service when it's available",
    help: 'Choose it if quoted and allowed to win; otherwise fall back to the cheapest.'
  },
  prefer_service: {
    label: "Prefer this service when it's within $X or Y% of the cheapest",
    help: 'Choose it when it is within $X or Y% of the cheapest price.'
  },
  add_tag: {
    label: 'Add a ShipStation tag',
    help: 'Add this tag when Rate Shop changes a matching order.'
  }
};
export const US_STATES =
  'AL AK AZ AR CA CO CT DE DC FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY'.split(
    ' '
  );

export const US_STATE_NAMES =
  'Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|District of Columbia|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming'.split(
    '|'
  );
